<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    width="600"
    height="149.85075"
    viewBox="0 0 600 149.85075"
    version="1.1"
    id="svg16"
    sodipodi:docname="mach.svg"
    inkscape:version="0.92.1 r15371">
    <defs
      id="defs11">
      <linearGradient
        x1="0.035946533"
        y1="0.035946533"
        x2="1"
        y2="1"
        id="linearGradient-1">
        <stop
          stop-color="currentColor"
          offset="0%"
          id="stop6"/>
        <stop
          stop-color="currentColor"
          offset="100%"
          id="stop8"/>
      </linearGradient>
      <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient-1"
        id="linearGradient4497"
        x1="9.11654"
        y1="9.11654"
        x2="253.61388"
        y2="253.61388"
        gradientTransform="scale(2.113449,0.47316022)"
        gradientUnits="userSpaceOnUse"/>
      <linearGradient
        inkscape:collect="always"
        xlink:href="#linearGradient-1"
        id="linearGradient4499"
        x1="9.11654"
        y1="9.11654"
        x2="253.61388"
        y2="253.61388"
        gradientTransform="scale(2.113449,0.47316022)"
        gradientUnits="userSpaceOnUse"/>
    </defs>
    <g
      id="Symbols"
      transform="matrix(1.0820896,0,0,1.0820896,10,10)"
      style="fill:none;fill-rule:evenodd;stroke:none;stroke-width:1">
      <g
        id="Logo"
        style="fill:currentColor">
        <path
          d="M 104.70195,0.67799216 C 105.89347,0.2213852 107.09879,0 108.31331,0 c 0.86489,0 1.73898,0.11530479 2.60846,0.34130218 2.16222,0.61342147 3.9058,1.80797912 5.23533,3.57906062 1.32954,1.7249597 1.992,3.6943655 1.992,5.9128296 V 109.88546 c 0,2.71659 -0.9707,5.02268 -2.90749,6.91368 -1.87699,1.93712 -4.17722,2.9149 -6.88689,2.9149 -2.71428,0 -5.04211,-0.97778 -6.97891,-2.9149 -1.932191,-1.891 -2.902889,-4.19709 -2.902889,-6.91368 V 45.125682 c 0,0 -31.388963,51.924053 -31.513175,52.122377 -0.906291,1.498962 -2.327835,2.536705 -3.901193,3.256211 -1.209922,0.56268 -2.562458,0.87631 -3.979401,0.87631 -1.426144,0 -2.774079,-0.31363 -3.988602,-0.87631 C 53.521792,99.784764 52.086447,98.779307 51.193958,97.257283 51.037542,96.999001 19.680783,45.125682 19.680783,45.125682 v 64.759778 c 0,2.71659 -0.966098,5.02268 -2.907493,6.91368 -1.936795,1.93712 -4.26463,2.9149 -6.9697023,2.9149 -2.7188739,0 -5.0145052,-0.97778 -6.8960948,-2.9149 C 0.97069779,114.90814 0,112.60205 0,109.88546 V 9.8331924 C 0,7.6147283 0.66246674,5.6453225 1.9920007,3.9203628 3.3215346,2.1492813 5.0697107,0.95472365 7.2273281,0.34130218 8.1060167,0.11530479 8.9755043,0 9.8403914,0 11.054914,0 12.255635,0.2213852 13.451755,0.67799216 15.498962,1.5081866 17.109124,2.864171 18.26844,4.7597817 L 59.079152,72.356061 99.880663,4.7597817 C 101.04458,2.864171 102.65474,1.5081866 104.70195,0.67799216 Z M 199.9462,5.6314859 C 201.10552,3.1870244 203.19413,0 208.8619,0 c 5.13871,0 7.76098,3.1870244 8.9249,5.6314859 L 264.92775,105.68837 c 1.16851,2.44907 1.29273,4.96272 0.38183,7.54554 -0.91089,2.58283 -2.58546,4.45999 -5.0237,5.63149 -2.43365,1.16689 -4.9363,1.29141 -7.50796,0.38281 -2.57166,-0.91782 -4.44405,-2.60127 -5.60796,-5.04573 L 208.8665,32.940272 170.55384,114.20248 c -1.16392,2.44446 -3.02711,4.12791 -5.59877,5.04573 -2.57626,0.9086 -5.08351,0.78408 -7.51715,-0.38281 -2.43825,-1.1715 -4.11282,-3.04866 -5.02371,-5.63149 -0.91089,-2.58282 -0.78208,-5.09647 0.38184,-7.54554 z M 311.87922,17.549389 C 323.5736,5.8482589 337.62801,0 354.05627,0 c 15.42075,0 28.8403,5.2025521 40.25405,15.621493 2.00581,1.844876 3.06391,4.137136 3.17432,6.886002 0.10582,2.744254 -0.74987,5.119532 -2.59466,7.139672 -1.83098,2.066262 -4.11281,3.159352 -6.84549,3.274656 -2.72807,0.106081 -5.09271,-0.761011 -7.09851,-2.605888 -7.57236,-6.94596 -16.52947,-10.414328 -26.88971,-10.414328 -10.9675,0 -20.35245,3.91575 -28.14564,11.756476 -7.79318,7.836113 -11.68977,17.268045 -11.68977,28.295795 0,11.119994 3.89659,20.547314 11.68977,28.388039 7.79319,7.836114 17.17814,11.751863 28.14564,11.751863 10.36024,0 19.31735,-3.463755 26.88971,-10.414327 2.0058,-1.840265 4.37044,-2.711969 7.09851,-2.596664 2.73268,0.110692 5.01451,1.19917 6.84549,3.270044 1.84479,2.024752 2.70048,4.395418 2.59466,7.139672 -0.11041,2.744255 -1.16851,5.041125 -3.17432,6.886005 C 382.89657,114.79284 369.47702,120 354.05627,120 c -16.42826,0 -30.48267,-5.84826 -42.17705,-17.54939 -11.63457,-11.756475 -17.44956,-25.892842 -17.44956,-42.4091 0,-16.599278 5.81499,-30.735645 17.44956,-42.492121 z M 519.39693,2.8780075 C 521.30612,0.95933584 523.59255,0 526.26542,0 c 2.66827,0 4.9593,0.95933584 6.86849,2.8780075 C 535.0431,4.8012914 536,7.1073872 536,9.7962949 V 110.20371 c 0,2.6889 -0.9569,4.99961 -2.86609,6.91367 -1.90919,1.92328 -4.20022,2.88262 -6.86849,2.88262 -2.67287,0 -4.9593,-0.95934 -6.86849,-2.88262 -1.9138,-1.91406 -2.86149,-4.22477 -2.86149,-6.91367 V 70.787916 h -60.10966 v 39.415794 c 0,2.6889 -0.92929,4.99961 -2.77868,6.91367 -1.90919,1.92328 -4.20022,2.88262 -6.86849,2.88262 -2.67747,0 -4.9639,-0.95934 -6.86849,-2.88262 -1.90919,-1.91406 -2.86609,-4.22477 -2.86609,-6.91367 V 9.7962949 c 0,-2.6889077 0.9569,-4.9950035 2.86609,-6.9182874 C 441.81471,0.95933584 444.10114,0 446.77861,0 c 2.66827,0 4.9593,0.95933584 6.86849,2.8780075 1.84939,1.9232839 2.77868,4.2293797 2.77868,6.9182874 V 51.278346 h 60.10966 V 9.7962949 c 0,-2.6889077 0.94769,-4.9950035 2.86149,-6.9182874 z"
          id="Combined-Shape"
          style="fill:currentColor"
          inkscape:connector-curvature="0"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'checkIcon'
}
</script>
